module.exports = __webpack_public_path__ + "img/empty-temp-introduce-1.cad673dd.jpg";